{
  "myWork": {
    "title": "Mon travail",
    "description": "Actions pour vous et votre équipe dans {{module}}",
    "approvalsLink": "Approbations →",
    "executiveLink": "Vue exécutive →",
    "scope": "Périmètre",
    "priority": "Priorité",
    "scopeMyTeam": "Mon équipe",
    "scopeAssignedToMe": "Assigné à moi",
    "priorityAny": "Toute priorité",
    "priorityCritical": "Critique",
    "priorityHigh": "Élevée",
    "priorityMedium": "Moyenne",
    "priorityLow": "Faible",
    "bucketAll": "Tout ouvert",
    "bucketAttention": "À traiter",
    "bucketDueToday": "Échéance aujourd'hui",
    "bucketOverdue": "En retard",
    "bucketAwaitingApproval": "En attente d'approbation",
    "bucketAwaitingResponse": "En attente de réponse",
    "kpiAttention": "À traiter",
    "kpiOverdue": "En retard",
    "kpiAwaitingApproval": "En attente d'approbation",
    "kpiAssignedToMe": "Assigné à moi",
    "sectionOpen": "Éléments ouverts",
    "empty": "Aucun élément dans ce filtre",
    "sectionWorkItems": "Éléments de travail",
    "sectionWorkItemsDesc": "Uniquement les éléments pour vous et les employés de votre périmètre",
    "sectionSuggestions": "Suggestions",
    "viewLink": "Voir →",
    "loading": "Chargement…",
    "emptyFilters": "Aucun élément ne correspond à vos filtres. Vous ne voyez que le travail pour vous et votre hiérarchie."
  },
  "toast": {},
  "errors": {
    "notificationActionFailed": "Échec de notification action",
    "failedToMarkNotificationRead": "Échec du marquage de la notification comme lue",
    "failedToLoadWorkQueue": "Échec du chargement de la file de travail"
  },
  "pages": {
    "dueToday": "Échéance aujourd'hui",
    "overdue": "En retard",
    "approvals": "Approbations",
    "assignedToMe": "Assigné à moi",
    "executiveCommandCenter": "Centre de commande exécutif",
    "executiveDescription": "Risques et alertes critiques pour {{module}}",
    "executiveEmpty": "Aucune alerte exécutive critique pour l'instant.",
    "investigateLink": "Enquêter →",
    "criticalRisks": "Risques critiques",
    "criticalWorkQueue": "File de travail critique",
    "notifications": "Alertes"
  },
  "card": {
    "employee": "Employé",
    "status": "Statut",
    "due": "Échéance",
    "open": "Ouvrir",
    "bucketUpcoming": "À venir",
    "bucketCompleted": "Terminé",
    "actionFailed": "Échec : {{action}}",
    "priorityInfo": "Information"
  },
  "labels": {}
}
